(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fts-sound"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fts-sound')) {
  customElements.define('fts-sound', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.audio = this.querySelector('audio');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-sound-label]');
      this.status = this.querySelector('[role="status"]');
      if (!this.audio || !this.button || !this.label || !this.status) return;
      this.audio.volume = 0.3;
      const render = () => {
        const active = !this.audio.paused;
        this.button.setAttribute('aria-pressed', String(active));
        this.label.textContent = active ? this.dataset.off : this.dataset.on;
      };
      const pause = () => this.audio.pause();
      const remember = (muted) => {
        try { sessionStorage.setItem('fts-sound-muted', String(muted)); } catch {}
      };
      this.button.addEventListener('click', async () => {
        this.status.textContent = '';
        if (!this.audio.paused) { remember(true); pause(); return; }
        try { await this.audio.play(); remember(false); }
        catch { this.status.textContent = this.dataset.error; render(); }
      }, { signal });
      this.audio.addEventListener('play', render, { signal });
      this.audio.addEventListener('pause', render, { signal });
      this.audio.addEventListener('error', () => {
        pause();
        this.status.textContent = this.dataset.error;
        render();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
      }, { signal });
      document.addEventListener('play', (event) => {
        if (event.target instanceof HTMLVideoElement && !event.target.muted) pause();
      }, { signal, capture: true });
      window.addEventListener('pagehide', pause, { signal });
      render();
      this.hidden = false;
      let muted = false;
      try { muted = sessionStorage.getItem('fts-sound-muted') === 'true'; } catch {}
      if (!muted && !document.hidden) {
        this.audio.play().catch(() => render());
      }
    }
    disconnectedCallback() {
      this.audio?.pause();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
